import { Component, Input } from 'angular-ts-decorators';

/**
 * Builds a card
 *
 * # Attributes:
 * * color
 * * name
 * * url
 * * icon - font awesome icon (object)
 */
@Component({
  selector: 'swColorCard',
  template: require('./sw-color-card.html').default,
})
export class SwColorCardComponent {
  @Input() color;
  @Input() name;
  @Input() url;
  @Input() icon;

  constructor() {
    'ngInject';
  }

  getClass(color) {
    return `sw-color-card--${color}`;
  }
}
